import Icon from '../components/Icon.vue'

Icon.register({"angle-double-left":{"width":1024,"height":1792,"paths":[{"d":"M627 1376q0 13-10 23l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23t-10 23l-393 393 393 393q10 10 10 23zM1011 1376q0 13-10 23l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23t-10 23l-393 393 393 393q10 10 10 23z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/angle-double-left.js
// module id = 310
// module chunks = 0